import React from 'react';
import { useTranslation } from '../i18n';

const SECTIONS = ['what', 'safety', 'price', 'easy', 'eco', 'offer'] as const;

export const HowItWorksPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="how-it-works">
      <h2>{t('hiw.title')}</h2>

      {SECTIONS.map((key) => (
        <section key={key}>
          <h3>{t(`hiw.${key}.title`)}</h3>
          <p>{t(`hiw.${key}.text`)}</p>
        </section>
      ))}
    </div>
  );
};
